<p>guest-reco-widget works!</p>
<div *ngIf="showMap">
  <app-guest-recommendations-map-desktop ></app-guest-recommendations-map-desktop>
</div>
